module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "padding10 bg-grayLighter"
  }, [_vm._v("Form")]), _vm._v(" "), _c('form', {
    staticClass: "flex-grid",
    attrs: {
      "action": ""
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4"
  }, [_c('datepicker')], 1)]), _vm._v(" "), _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Company")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4"
  }, [_c('vi-select', {
    attrs: {
      "options": _vm.options
    }
  })], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4 input-control"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your name"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4 input-control"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your email"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4 input-control"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your phone number"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4"
  }, [_c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "gender",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Male")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "gender"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Female")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label cell colspan2 align-right"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan4"
  }, [_c('textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "rows": "4"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row form-group"
  }, [_c('section', {
    staticClass: "cell colspan8 row flex-just-center padding20"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Reset")]), _vm._v("   \n        "), _c('button', {
    staticClass: "button primary"
  }, [_vm._v("Submit")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dcdc4e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demo3.vue
// module id = 392
// module chunks = 1